module.exports = __webpack_public_path__ + "static/media/logo_ign.7c97e0ad.png";